;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: "TKash",
    props: ["callback_url", "currency", "logo", "amount_net", "invoice_no", "gid", "fee", "bill_ref", "service_id", "agent_fee", "notification_url", "status_api_url", "base_url", "mpgs_api_url", "instructions"],
    data: function data() {
        return {
            div_id: "",
            content_div: "",
            payment_instructions: "",
            stkOpen: true,
            stkPhone: null,
            step: 1,
            show_confirmation: true,
            success_message: "",
            total_amount: 0
        };
    },
    created: function created() {
        this.div_id = "tkashModal" + this.gid;
        this.content_div = "tkash_content" + this.gid;
        this.payment_instructions = this.instructions;
    },
    mounted: function mounted() {
        this.set_total_amount();
    },
    computed: {
        valid_phone: function valid_phone() {
            if (this.stkPhone) {
                if (this.stkPhone.match(/\d{9}/g)) {
                    return true;
                }
            }
            return false;
        }
    },
    methods: {
        write_instructions: function write_instructions(div, instructions) {
            $("#" + div).html(instructions);
        },

        formatNumber: function formatNumber(num) {
            return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        },
        set_total_amount: function set_total_amount() {
            this.total_amount = parseFloat(this.amount_net) + parseFloat(this.fee) + parseFloat(this.agent_fee);
        },
        showTextInput: function showTextInput() {
            this.write_instructions(this.content_div, this.payment_instructions);
            this.stkOpen = !this.stkOpen;
            this.show_confirmation = false;
        },
        destroyTimer: function destroyTimer() {
            this.$refs.timer.destroyTimer();
        },
        stkPush: function stkPush() {
            var _this = this;

            var url = this.base_url + "/api/payment/tkash/checkout";
            var data = {
                invoice_number: this.invoice_no,
                gateway_id: this.gid,
                amount: this.total_amount,
                msisdn: this.stkPhone,
                callback_url: this.callback_url
            };
            Vue.axios.post(url, data).then(function (response) {
                if (response.data.status == "success") {
                    _this.success_message = "Check your phone for USSD Menu. Press Complete once done.";
                    _this.error_message = null;
                    _this.show_confirmation = true;
                } else {
                    _this.error_message = response.data.message;
                }
            }).catch(function (error) {
                _this.error_message = "Unable to push USSD Menu. Please try again later.";
                _this.success_message = null;
            }).catch(function (error) {
                _this.initiating = false;
                _this.loading = false;
                _this.error_message = "Unable to push USSD Menu. Please try again later.";
                _this.success_message = null;
            });
        }
    }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":_vm.div_id,"tabindex":"-1","role":"dialog","aria-labelledby":"tkashModalLabel","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-full",attrs:{"role":"document"}},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body d-flex align-items-center"},[(_vm.step == 1)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-6 mx-auto"},[_c('img',{staticClass:"navbar-brand-img",attrs:{"src":_vm.logo,"alt":"..."}}),_vm._v(" "),_c('div',{staticClass:"card mt-3"},[_c('div',{staticClass:"card-header d-flex justify-content-between"},[_c('p',{staticClass:"mb-0"},[_vm._v("Pay Using TKash")]),_vm._v(" "),_c('p',{staticClass:"mb-0 lead"},[_vm._v(_vm._s(_vm.currency)+" "+_vm._s(_vm.formatNumber(_vm.total_amount)))])]),_vm._v(" "),_c('div',{staticClass:"container"},[(_vm.error_message)?_c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_vm._v("\n                                        "+_vm._s(_vm.error_message)+"\n                                    ")]):_vm._e(),_vm._v(" "),(_vm.success_message)?_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n                                        "+_vm._s(_vm.success_message)+"\n                                    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('ol',[_c('li',[_vm._v("\n                                                Click\n                                                "),_c('a',{attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.stkOpen = !_vm.stkOpen}}},[_vm._v("here")]),_vm._v("\n                                                to receive TKash Menu\n                                            ")]),_vm._v(" "),(_vm.stkOpen)?_c('form',{staticClass:"card-body",on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.stkPhone),expression:"stkPhone"}],staticClass:"form-control",attrs:{"placeholder":"Enter a valid TKash number","type":"text","required":""},domProps:{"value":(_vm.stkPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.stkPhone=$event.target.value}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"btn btn-sm btn-primary text-center",attrs:{"disabled":_vm.loading},on:{"click":_vm.stkPush}},[_vm._v("Initiate\n                                                        Payment")])])]):_vm._e(),_vm._v(" "),_c('li',[_vm._v("Enter your TKash PIN and click OK")]),_vm._v(" "),_c('li',[_vm._v("You will receive a confirmation SMS from TKash")])]),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._v("\n                                            After you receive a successful reply from TKash, click\n                                            the complete button below.\n                                        ")])]),_vm._v(" "),_c('div',[(_vm.content_div)?_c('div',{staticClass:"card-body"},[_c('p',[_vm._v("Or follow instructions below")]),_vm._v(" "),_c('div',{attrs:{"id":_vm.content_div},domProps:{"innerHTML":_vm._s(_vm.payment_instructions)}})]):_vm._e()])]),_vm._v(" "),(_vm.show_confirmation)?_c('div',{staticClass:"card-footer d-flex justify-content-end align-items-center"},[_c('button',{staticClass:"btn btn-link text-dark px-5",attrs:{"data-dismiss":"modal"},on:{"click":_vm.destroyTimer}},[_vm._v("Cancel")]),_vm._v(" "),_c('complete-button',{ref:"timer",attrs:{"gateway":"tkash","status_api_url":_vm.status_api_url,"invoice_no":_vm.invoice_no,"callback_url":_vm.callback_url}})],1):_vm._e()])])])]):_vm._e()])])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header d-flex align-items-center"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"fe fe-x text-dark",attrs:{"aria-hidden":"true"}},[_vm._v("x")])])])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51f9ddb1", __vue__options__)
  } else {
    hotAPI.reload("data-v-51f9ddb1", __vue__options__)
  }
})()}